import { Pipe, PipeTransform } from '@angular/core';
import { AssetImports } from '../../../core/store/models';


@Pipe({
    name: 'getAssetCount',
    standalone: false
})
export class GetAssetCountPipe implements PipeTransform {
    transform(assetImport: AssetImports) {
        return assetImport && assetImport.assets ? assetImport.assets.length : null;
    }
}

@Pipe({
    name: 'getAcceptedAssetsCount',
    standalone: false
})
export class GetAcceptedAssetsCountPipe implements PipeTransform {
    transform(ai: AssetImports) {
        return ai && ai.assets ? ai.assets.filter(t => !(t.for_review)).length : null;
    }
}

@Pipe({
    name: 'getForReviewAssetsCount',
    standalone: false
})
export class GetForReviewAssetsCountPipe implements PipeTransform {
    transform(ai: AssetImports) {
        return ai && ai.assets ? ai.assets.filter(t => (t.for_review)).length : null;
    }
}

/** Count of ALL Assets from all imports */
@Pipe({
    name: 'getAssetsTotal',
    standalone: false
})
export class GetAssetsTotalPipe implements PipeTransform {
    transform(imports: AssetImports[]) {
        return (imports) ? imports.reduce((sum, ai) => {
            return ai && ai.assets ? sum + ai.assets.length : sum;
        }, 0) : 0;
    }
}

@Pipe({
    name: 'getAcceptedAssetsTotal',
    standalone: false
})
export class GetAcceptedAssetsTotalPipe implements PipeTransform {
    transform(imports: AssetImports[]) {
        return (imports) ? imports.reduce((sum, ai) => {
            return ai && ai.assets ? sum + ai.assets.filter(a => !a.for_review).length : sum;
        }, 0) : 0;
    }
}

@Pipe({
    name: 'getForReviewAssetsTotal',
    standalone: false
})
export class GetForReviewAssetsTotalPipe implements PipeTransform {
    transform(imports: AssetImports[]) {
        return (imports) ? imports.reduce((sum, ai) => {
            return ai && ai.assets ? sum + ai.assets.filter(a => a.for_review).length : sum;
        }, 0) : 0;
    }
}